/**
 * 前端 API 客户端
 * 嵌入模式（Shopify Admin iframe）: App Bridge idToken() → Authorization Bearer
 * 开发模式: ?shop= query + X-Shopify-Shop-Domain header
 */

declare global {
  interface Window { shopify?: { idToken: () => Promise<string> } }
}

function getShop(): string {
  const params = new URLSearchParams(window.location.search);
  return params.get('shop') || localStorage.getItem('dev_shop') || 'dev-shop.myshopify.com';
}

const isEmbedded = () => !!window.shopify?.idToken;

export async function api<T = any>(path: string, options: RequestInit = {}): Promise<T> {
  const headers: Record<string, string> = {
    'Content-Type': 'application/json',
    ...(options.headers as Record<string, string> || {}),
  };

  const url = new URL(path, window.location.origin);

  if (isEmbedded()) {
    const token = await window.shopify!.idToken();
    headers['Authorization'] = `Bearer ${token}`;
  } else {
    const shop = getShop();
    url.searchParams.set('shop', shop);
    headers['X-Shopify-Shop-Domain'] = shop;
  }

  const res = await fetch(url.toString(), { ...options, headers });

  if (!res.ok) {
    const body = await res.json().catch(() => ({}));
    throw new Error((body as any).error || (body as any).message || `HTTP ${res.status}`);
  }
  return await res.json() as T;
}

export const get = <T = any>(path: string) => api<T>(path);
export const post = <T = any>(path: string, body?: any) =>
  api<T>(path, { method: 'POST', body: body !== undefined ? JSON.stringify(body) : undefined });
export const put = <T = any>(path: string, body?: any) =>
  api<T>(path, { method: 'PUT', body: body !== undefined ? JSON.stringify(body) : undefined });
export const del = <T = any>(path: string) => api<T>(path, { method: 'DELETE' });
